export var AlertState;

(function (AlertState) {
  AlertState["SUCCESS"] = "success";
  AlertState["FAILURE"] = "failure";
})(AlertState || (AlertState = {}));